import { User } from '../user/user-model';
import { Shippment } from '../shippment/shippment-model';
import { OrderDetail } from './order-detail.model';
import { Customer } from '../customer/customer-model';
import { Order } from './order.model';
import { Coupon } from '../coupons/coupon-model';
import { Product } from '../products/product.model';
import { Brand } from '../brand/brand-model';

export class OrderViewModel {
  public shippingCountry: string;
  public shippingState: string;
  public billingCountry: string;
  public billingState: string;
  public strShippingMethod: string;
  public paymentStatus: string;
  public orderDetails: OrderDetail[];
  //public ShippingMethod: ShippingMethod;
  public strPaymentMethod: string;
  public strOrderStatus: string;
  public customer: Customer;
  public order: Order;
  public coupon: Coupon;
}
export class PrintOrdersList extends OrderViewModel  {
  public brands: Brand[] = [];
  public products: Product[] = [];
  public vendors: Customer[] = [];

}
export class ReturnStatus
{
  public code :String;
  public status:string;
  public message:string;
  public requestTime:string;
  public responseTime:string;
}
export class BookingReply
{
  public result:string;
}



// WEBPACK FOOTER //
// ./src/app/models/order/order-view-model.model.ts